// src/components/support/MediaModal.jsx
import React, { useEffect } from "react";

const MediaModal = ({ isOpen, onClose, media }) => {
  if (!isOpen || !media) return null;

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[60] bg-black/60 flex items-center justify-center px-4 sm:px-6"
      onClick={handleBackdropClick}
    >
      <div className="relative bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl max-w-4xl w-full max-h-[85vh] flex flex-col overflow-hidden">
        {/* Close button */}
        <button
          type="button"
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 focus:outline-none"
          aria-label="Close"
        >
          <span className="text-xl leading-none">×</span>
        </button>

        {/* Title */}
        <div className="px-5 sm:px-6 pt-5 sm:pt-6 pb-3 border-b border-gray-200">
          <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900">
            {media.title}
          </h2>
        </div>

        {/* Media content */}
        <div className="flex-1 px-5 sm:px-6 pb-5 sm:pb-6 pt-4 flex items-center justify-center">
          {media.type === "video" && media.youtubeId && (
            <div className="w-full aspect-video bg-black rounded-xl overflow-hidden shadow-lg">
              <iframe
                src={`https://www.youtube.com/embed/${media.youtubeId}`}
                title={media.title || "Support video"}
                className="w-full h-full"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          )}
          {media.type === "photo" && media.imageUrl && (
            <div className="w-full max-h-[70vh] flex items-center justify-center">
              <img
                src={media.imageUrl}
                alt={media.title || "Support image"}
                className="max-w-full max-h-[70vh] object-contain rounded-xl shadow-lg"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MediaModal;







